import { Stack, InputLabel, FormControlLabel, Checkbox, SxProps, Theme, Box, Switch, Divider } from '@mui/material'
import { GruposAtributos } from '../../../Integraciones/types/responses'
import { GruposRubros } from '../../../Integraciones/Importacion/types/atributos'
import CheckboxGroup from './CheckBox'

interface AtributosRubroProps {
  atributos: GruposAtributos[]
  gruposSeleccionados: any[]
  setGruposSeleccionados: (g: any[]) => void
  flagsConfig: any
  setFlagsConfig: (f: any) => void
  isMobile: boolean
  loading: boolean
}

/* eslint-disable react/prop-types */
const AtributosRubro: React.FC<AtributosRubroProps> = ({
  atributos,
  gruposSeleccionados,
  setGruposSeleccionados,
  flagsConfig,
  setFlagsConfig,
  isMobile,
  loading
}) => {
  const handleGrupoSeleccionado = (idGrupo: number) => {
    if (gruposSeleccionados.some((g: number) => g === idGrupo)) {
      setGruposSeleccionados(gruposSeleccionados.filter((g: number) => g !== idGrupo))
    } else {
      setGruposSeleccionados([...gruposSeleccionados, idGrupo])
    }
  }

  const toggleFlag = (slug: string, key: 'obligatorio' | 'puedeCargarValorLibre') => {
    const cur = flagsConfig[slug] || { obligatorio: false, puedeCargarValorLibre: false }
    setFlagsConfig({ ...flagsConfig, [slug]: { ...cur, [key]: !cur[key] } })
  }

  return (
    <>
      {atributos.map((g: GruposRubros) => (
        <Stack key={g.slug}>
          <InputLabel sx={{ fontSize: '16px', marginBottom: '0.5rem' }}>{g.nombrePlural}</InputLabel>

          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: isMobile ? '1fr' : '1fr auto 1fr',
              columnGap: '16px',
              alignItems: 'start'
            }}
          >
            <Stack>
              <CheckboxGroup
                label="Grupos de valores"
                items={g.grupos}
                getKey={(unit) => unit.idGrupo}
                getLabel={(unit) => `${unit.nombre}`}
                isChecked={(unit) => gruposSeleccionados.some((g: number) => g === unit.idGrupo)}
                onChange={(unit) => handleGrupoSeleccionado(unit.idGrupo)}
                disabled={loading}
              />
            </Stack>

            {!isMobile && <Divider orientation="vertical" flexItem />}

            <Stack spacing={2}>
              <FormControlLabel
                control={
                  <Switch
                    checked={flagsConfig[g.slug]?.obligatorio || false}
                    onChange={() => toggleFlag(g.slug, 'obligatorio')}
                    disabled={loading}
                  />
                }
                label="Obligatorio"
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={flagsConfig[g.slug]?.puedeCargarValorLibre || false}
                    onChange={() => toggleFlag(g.slug, 'puedeCargarValorLibre')}
                    disabled={loading}
                  />
                }
                label="Permite valor libre"
              />
            </Stack>
          </Box>

          <Divider sx={{ mt: '16px' }} />
        </Stack>
      ))}
    </>
  )
}

export default AtributosRubro
